import { Box, Flex, Stack, useBreakpointValue } from '@chakra-ui/react';
import Button from '~/components/Button';
import LinkButton from '~/components/LinkButton';

import { ArrowLeftIcon, ArrowRightIcon } from '../icons';
import { usePagination } from './usePagination';

// eslint-disable-next-line react/prop-types
const MobilePagination = ({ count, page }: any) => {
  return (
    <Flex fontSize="sm" fontWeight="bold" align="center" marginX="auto">
      {page} of {count}
    </Flex>
  );
};

const Pagination = ({ count, page, onChange, ...rest }: any) => {
  const isMobileView = useBreakpointValue({ base: true, md: false });
  const previousPage = Math.max(0, page - 1);
  const nextPage = Math.min(count, page + 1);

  const handlePrevClick = () => {
    onChange(previousPage);
  };

  const handleNextClick = () => {
    onChange(nextPage);
  };

  // e.g. itemList = [ 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10]
  const itemList = usePagination(count, page);

  const paginationItem = (item: any) => {
    if (typeof item === 'number') {
      return (
        <Button
          key={item}
          width="40px"
          aria-label={`Go to page ${item}`}
          variant={item === page ? 'solid' : 'ghost'}
          colorScheme={item === page ? 'primary' : 'gray'}
          data-testid={item === page ? `page-${item}-selected` : `page-${item}`}
          onClick={() => onChange(item)}
        >
          {item}
        </Button>
      );
    } else {
      return (
        <LinkButton as="span" pointerEvents="none" key={item}>
          ...
        </LinkButton>
      );
    }
  };

  if (count < 2) {
    return null;
  }

  return (
    <Stack
      as="nav"
      spacing={2}
      direction="row"
      aria-label="Page navigation"
      justifyContent={{ base: 'space-between', md: 'center' }}
      {...rest}
    >
      {page > 1 && (
        <Button
          colorScheme="primary"
          onClick={handlePrevClick}
          pointerEvents={page <= 1 ? 'none' : 'initial'}
          aria-label="Go to previous page"
        >
          <ArrowLeftIcon boxSize="24px" marginRight={{ base: 0, md: 2 }} />
          <Box display={{ base: 'none', md: 'block' }}>Prev</Box>
        </Button>
      )}
      {isMobileView ? (
        <MobilePagination page={page} count={count} />
      ) : (
        itemList.map((item) => paginationItem(item))
      )}
      {page < count && (
        <Button
          colorScheme="primary"
          onClick={handleNextClick}
          pointerEvents={page >= count ? 'none' : 'initial'}
          aria-label="Go to next page"
        >
          <Box display={{ base: 'none', md: 'block' }}>Next</Box>
          <ArrowRightIcon boxSize="24px" marginLeft={{ base: 0, md: 2 }} />
        </Button>
      )}
    </Stack>
  );
};

export default Pagination;
